import React, { useEffect, useMemo, useState } from 'react';
import { DBO_TM } from '@op/utils/format';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { VideoTagInsightPoint } from '@op/operationLog/pages';
import { formatAITagsFilterValue, isSpecialEdition } from '../components/utils';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import { useNavigatorScroll } from '@op/components/Navigator';
import CardLoading from '@op/components/CardLoading';
import TagAnalysisCard from '../components/TagAnalysisCard';

interface IVideoTagInsightProps {
  gameInfo: any;
  wholeGameInfo: any;
  isSupportVideoTags: boolean;
  scrollBody: React.RefObject<HTMLElement>;
  onScrollHandlerReady?: (handler: (e: any) => void) => void;
}
export const defaultNavigator = 'Overview';
const VideoTagInsight = (props: IVideoTagInsightProps) => {
  const { gameInfo, scrollBody, onScrollHandlerReady } = props;
  const {
    loading,
    filter,
    changeFilter,
    filterOptions,
    changeOtherPageParams,
  } = useFilterDataHook({
    gameInfo,
    hasHero: true,
    hasVideoTag: true,
    pageName: 'Community_Video',
  });

  useInitBuriedPointInfo({ buriedPoint: VideoTagInsightPoint });

  const [tagOptions, setTagOptions] = useState([]);
  const [navigators, setNavigators] = useState<any>([]);
  const { selectNavigator, setSelectNavigator, handleScroll } =
    useNavigatorScroll({
      allKeys: [{ label_en: defaultNavigator }, ...navigators].map(
        (item) => item.label_en,
      ),
      defaultValue: defaultNavigator,
      refBody: scrollBody.current,
      debounceTime: 10,
    });

  // 将 handleScroll 传递给父组件
  useEffect(() => {
    if (onScrollHandlerReady && handleScroll) {
      onScrollHandlerReady(handleScroll);
    }
  }, [handleScroll, onScrollHandlerReady]);

  const filterParams = useMemo(() => {
    return {
      ...filter,
      video_tags: formatAITagsFilterValue(filter?.video_tags),
    };
  }, [filter]);

  return (
    <div className="dbo-video-tag-insight-wrapper">
      <FilterFixed
        filter={filterOptions}
        confirm={(value) => {
          const { video_tags: videoTags } = value || {};
          const selectedTags = videoTags?.map((val: any) => val.t1) || [];
          const navigatorsList = selectedTags?.length > 0 ? tagOptions?.filter((val: any) => selectedTags?.includes(val.label_en)) : tagOptions;
          setNavigators(navigatorsList);

          changeFilter({
            ...value,
            media_types: ['video', 'live'],
            review_types: ['posts_video', 'stream_titles'],
          });
        }}
        finallyDealwithDefaultValue={(
          value: any,
          otherPageParams: any,
          isDefaultValue = false,
        ) => {
          !isDefaultValue && changeOtherPageParams(otherPageParams || {});
          return value;
        }}
        defaultConfig={{ channel: { channelKey: 'social' } }}
        defaultValue={DBO_TM.utcFilterRangeDay(6, 0)}
        backCondOriginData={(options) => {
          const { video_tags: videoTags } = options;
          const filteredTags = isSpecialEdition(gameInfo)
            ? videoTags?.filter((val: any) => val.label_en !== 'Video Category')
            : videoTags;
          setTagOptions(filteredTags);
        }}
      ></FilterFixed>
      <CardLoading loading={loading}>
        <TagAnalysisCard
          gameInfo={gameInfo}
          filter={filterParams}
          navigators={navigators}
          defaultNavigator={defaultNavigator}
          selectNavigator={selectNavigator}
          setSelectNavigator={setSelectNavigator}
          scrollBody={scrollBody}
          tagOptions={tagOptions}
        />
      </CardLoading>
    </div>
  );
};

export default VideoTagInsight;
